export enum ConsumptionActionTypes {
  REQUEST_CONSUMPTION_SPACES_START = '@@consumption/REQUEST_CONSUMPTION_SPACES_START',
  REQUEST_CONSUMPTION_SPACES_SUCCESS = '@@consumption/REQUEST_CONSUMPTION_SPACES_SUCCESS',
  REQUEST_METERS_START = '@@consumption/REQUEST_METERS_START',
  REQUEST_METERS_SUCCESS = '@@consumption/REQUEST_METERS_SUCCESS',
  REQUEST_CONSUMPTIONS_START = '@@consumption/REQUEST_CONSUMPTIONS_START',
  REQUEST_CONSUMPTIONS_SUCCESS = '@@consumption/REQUEST_CONSUMPTIONS_SUCCESS',
  SET_ERROR_STATUS = '@@consumption/SET_ERROR_STATUS',
  SET_START_DATE = '@@consumption/SET_START_DATE',
  SET_END_DATE = '@@consumption/SET_END_DATE',
  SELECT_SPACE = '@@consumption/SELECT_SPACE',
  SET_INITIAL_DATA = '@@consumption/SET_INITIAL_DATA',
  SELECT_METER = '@@consumption/SELECT_METER',
  SET_SORT_PARAMS = '@@consumption/SET_SORT_PARAMS',
  RESET_STATE = '@@consumption/RESET_STATE',
}
